import { Component, Setter, createSignal, onCleanup } from "solid-js";
import { generateString } from "./utils/generateString";

const refresh = (value: string, setValue: Setter<string>) => {
  let step = 0;

  const interval = setInterval(() => {
    setValue(generateString(value, step));
    step++;
    if (step > value.length) clearInterval(interval);
  }, 50);

  return interval;
};

export interface HackerProps {
  children: string;
}

export const Hacker: Component<HackerProps> = (props) => {
  // Capture the initial text value - safe to access once at initialization
  // eslint-disable-next-line solid/reactivity
  const text = props.children ?? "";
  const [value, setValue] = createSignal(text);
  let interval: ReturnType<typeof setInterval> | undefined;

  const onInteraction = () => {
    // Guard against empty/undefined children
    if (!text) return;

    // Clean up existing interval before creating a new one
    if (interval !== undefined) {
      clearInterval(interval);
    }

    interval = refresh(text, setValue);
  };

  onCleanup(() => {
    if (interval !== undefined) {
      clearInterval(interval);
    }
  });

  return (
    <span
      onMouseOver={onInteraction}
      onFocus={onInteraction}
      tabIndex={0}
      role="button"
      aria-label={`Animated text: ${text}`}
    >
      {value()}
    </span>
  );
};
